import type { RtlItem } from '../../config-provider/src/internal-interface'
import rtlStyle from '../src/styles/input-otp-rtl.cssr'

export const inputOtpRtl: RtlItem = {
  name: 'InputOtp',
  style: rtlStyle
}
